// extracted by mini-css-extract-plugin
module.exports = {"createButton":"EditTaskForm_createButton__2Qrl7","taskFormContainer":"EditTaskForm_taskFormContainer__3mfey"};